"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSsn = void 0;
var validateDateOfBirth_1 = require("./validateDateOfBirth");
var validateControlDigits_1 = require("./validateControlDigits");
var validateIndividualDigits_1 = require("./validateIndividualDigits");
var ValidationErrorCode_1 = require("./ValidationErrorCode");
var ValidationResult_1 = require("./ValidationResult");
var validateSsn = function (value) {
    if (!/\d{11}/.test(value))
        return new ValidationResult_1.ValidationResult(ValidationErrorCode_1.ValidationErrorCode.InvalidSsnFormat);
    var dateOfBirth = validateDateOfBirth_1.getDateOfBirthFromSsn(value);
    var individualDigits = Number(value.slice(6, 9));
    if (!validateDateOfBirth_1.validateDateOfBirth(dateOfBirth))
        return new ValidationResult_1.ValidationResult(ValidationErrorCode_1.ValidationErrorCode.InvalidBirthDate);
    if (!validateIndividualDigits_1.validateIndividualDigits(individualDigits, dateOfBirth))
        return new ValidationResult_1.ValidationResult(ValidationErrorCode_1.ValidationErrorCode.InvalidIndividualDigits);
    if (!validateControlDigits_1.validateControlDigits(value))
        return new ValidationResult_1.ValidationResult(ValidationErrorCode_1.ValidationErrorCode.InvalidControlDigits);
    return new ValidationResult_1.ValidationResult();
};
exports.validateSsn = validateSsn;
//# sourceMappingURL=validateSsn.js.map